import React, { useCallback, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useI18n } from '../../utils/i18n';
import { useFeature } from '../../utils/featuresCache';
import { useBenutzerEinstellungen } from '../../services/benutzerEinstellungen';
import KayCeeKopf from '../header/KayCeeKopf';
import AssistentChat from './AssistentChat';
import { useAssistent } from './AssistentProvider';
import { assistentPosition } from './position';
import './assistent.css';

// #512: Schwebender Knopf mit dem KayCee-Kopf, unten rechts (oder links, nach
// Einstellung `assistent.position`), in jeder Ansicht am Arbeitsplatz. Ein
// Klick klappt die Sprechblase mit dem Chat aus. Ob sie offen ist, steht im
// AssistentProvider oberhalb des Routers: Sie bleibt beim Ansichtswechsel
// offen, auch während eine Antwort läuft.
//
// Für alle Rollen, nur mit `searchAi` (Beschluss 23.10.); erzwungen wird der
// Schalter auf dem Server. Mobil (/m) gibt es keinen schwebenden Knopf, dort
// sitzt unten rechts „+“, und der Assistent hängt am Knopf im Kopf.
// Den Knopf gibt es erst mit dem Einstellungs-Stand, also nach der Anmeldung.

const AssistentKnopf = () => {
  const { t } = useI18n();
  const { pathname } = useLocation();
  const kiAn = useFeature('searchAi');
  const einstellungen = useBenutzerEinstellungen();
  const { offen, setOffen, laeuft } = useAssistent();

  const oeffneTicket = useCallback((karte) => {
    if (!karte || karte.ticketId == null) return;
    try { window.dispatchEvent(new CustomEvent('openTicketDetailById', { detail: { ticketId: karte.ticketId } })); } catch (_) {
      // ohne CustomEvent (sehr alte Browser) bleibt nur die Karte stehen
    }
  }, []);

  // ESC schließt die Blase, aber nur, wenn der Fokus in ihr steht: Modals
  // darüber haben ihr eigenes ESC.
  useEffect(() => {
    if (!offen) return undefined;
    const taste = (e) => {
      if (e.key === 'Escape' && e.target && e.target.closest && e.target.closest('.assistent-schwebend')) setOffen(false);
    };
    document.addEventListener('keydown', taste);
    return () => document.removeEventListener('keydown', taste);
  }, [offen, setOffen]);

  if (!einstellungen || !kiAn || pathname.startsWith('/m') || pathname.startsWith('/setup')) return null;
  const seite = assistentPosition(einstellungen);

  return (
    <div className={`assistent-schwebend assistent-schwebend--${seite}`}>
      {offen && (
        <div className="assistent-sprechblase">
          <AssistentChat onClose={() => setOffen(false)} onOeffneTicket={oeffneTicket} />
        </div>
      )}
      <button
        type="button"
        className={`assistent-rund${offen ? ' assistent-rund--offen' : ''}${laeuft ? ' assistent-rund--arbeitet' : ''}`}
        data-seite={seite}
        onClick={() => setOffen(!offen)}
        aria-expanded={offen}
        aria-label={offen ? t('assistent.schliessen', 'Assistent schließen') : t('assistent.oeffnen', 'KayCee-Assistent öffnen')}
        title={offen ? t('assistent.schliessen', 'Assistent schließen') : t('assistent.oeffnen', 'KayCee-Assistent öffnen')}
      >
        <KayCeeKopf size={30} />
      </button>
    </div>
  );
};

export default AssistentKnopf;
